import { KeyboardEvent } from "react";

type SelectOption = {
  disabled?: boolean;
  value: string;
  border?: boolean;
  displayText?: string;
  label?: string;
};

type HandleKeyDownParams = {
  event: KeyboardEvent<HTMLElement>;
  isOpen: boolean;
  disabled: boolean;
  options: readonly SelectOption[];
  focusedIndex: number;
  value: string | undefined;
  onSelect: (value: string) => void;
  setIsOpen: (isOpen: boolean) => void;
  setFocusedIndex: (index: number) => void;
  searchable?: boolean;
};

export const handleKeyDown = ({
  event,
  isOpen,
  disabled,
  options,
  focusedIndex,
  onSelect,
  setIsOpen,
  setFocusedIndex,
  searchable = false
}: HandleKeyDownParams) => {
  if (disabled) return;

  switch (event.key) {
    case "ArrowDown":
      event.preventDefault();
      if (!isOpen) {
        setIsOpen(true);
      } else if (options.length > 0) {
        setFocusedIndex(Math.min(focusedIndex + 1, options.length - 1));
      }
      break;
    case "ArrowUp":
      event.preventDefault();
      if (!isOpen) {
        setIsOpen(true);
      } else if (options.length > 0) {
        setFocusedIndex(Math.max(focusedIndex - 1, 0));
      }
      break;
    case "Enter":
      event.preventDefault();
      if (isOpen && focusedIndex >= 0 && options[focusedIndex]) {
        onSelect(options[focusedIndex].value);
      } else {
        setIsOpen(true);
      }
      break;
    case " ":
      if (searchable) {
        return;
      }
      event.preventDefault();
      if (isOpen && focusedIndex >= 0 && options[focusedIndex]) {
        onSelect(options[focusedIndex].value);
      } else {
        setIsOpen(true);
      }
      break;
    case "Escape":
      event.preventDefault();
      setIsOpen(false);
      break;
    case "Tab":
      setIsOpen(false);
      break;
  }
};
